interface ResultCountProps {
  count: number;
  isLoading?: boolean;
}

export const ResultCount = ({ count, isLoading }: ResultCountProps) => {
  if (isLoading) {
    return <span className="text-sm text-gray-500">Loading...</span>;
  }

  return (
    <span className="text-sm text-gray-600 font-medium">
      {count.toLocaleString()} {count === 1 ? 'result' : 'results'}
    </span>
  );
};
